import { useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { checkSessionStatus, isTokenExpiringSoon } from '../utils/sessionManager';
import { checkResponseForTokenErrors } from '../utils/tokenErrorHandler';

export const useTokenValidation = () => {
  const navigate = useNavigate();

  // Check session status on mount and set up periodic checks
  useEffect(() => {
    // Initial check
    if (!checkSessionStatus(navigate)) {
      return;
    }

    // Set up periodic checks every 30 seconds
    const interval = setInterval(() => {
      if (!checkSessionStatus(navigate)) {
        clearInterval(interval);
        return;
      }

      // Warn user if token is expiring soon
      if (isTokenExpiringSoon()) {
        console.warn('Token will expire soon. Consider refreshing the session.');
      }
    }, 30000); // Check every 30 seconds

    return () => clearInterval(interval);
  }, [navigate]);

  // Function to handle API responses and check for token errors
  const handleApiResponse = useCallback((response: any): boolean => {
    return checkResponseForTokenErrors(response, navigate);
  }, [navigate]);

  return {
    handleApiResponse,
    checkSessionStatus: () => checkSessionStatus(navigate)
  };
}; 